import React from "react";
import Card from "../Card";
import { IoMdArrowBack } from "react-icons/io";
import { timeDiffer } from "../../utils/helper";

export default function FeatureView({ params, onUserClick, handleBackBtn }) {
  const userFirstLetter = params.featureName;
  const textComponent = (title, value, text) => {
    return (
      <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <p className="text-sm text-gray-600">{title}</p>
        <p className="text-base font-medium text-navy-700 dark:text-white">
          {value} <span className=" text-sm">{text || ""}</span>
        </p>
      </div>
    );
  };
  return (
    <>
      
      <Card extra={"w-full h-full p-3"}>
        <IoMdArrowBack onClick={() => handleBackBtn(null)} />
        {/* Header */}
        <div className="mt-2 mb-8 w-full">
          <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white uppercase">
            {params.featureName}
          </h4>
          {/* <p className="mt-2 px-2 text-base text-gray-600">
                As we live, our hearts turn colder. Cause pain is what we go through
                as we become older. We get insulted by others, lose trust for those
                others. We get back stabbed by friends. It becomes harder for us to
                give others a hand. We get our heart broken by people we love, even
                that we give them all...
              </p> */}
        </div>
        {/* Cards */}
        <div className="grid grid-cols-2 gap-4 px-2">
          {textComponent("Feature Name", params.featureName)}
          {textComponent("No of Visitors", params.visitedUserInfo.length)}
          {textComponent(
            "No of paid users visited",
            params.PaidUserClicks.length
          )}
          {textComponent(
            "No of free trail visited",
            params.FreeTrailsUserClicks.length
          )}
          {textComponent(
            "Created at",
            timeDiffer(params.created_at) + " " + "ago"
          )}

          {textComponent(
            "Feature Type",
            params.type
          )}
        </div>
      </Card>
      <Card extra={"w-full h-full p-6 mt-2"}>
        <div className="mt-2 mb-8 w-full">
          <h3 className="px-2 font-bold text-navy-700 dark:text-white uppercase">
            {"All involved pages and events"}
          </h3>
        </div>
        <ol className="relative border-s border-gray-200 dark:border-gray-700">
          {params.eventList.map((item) => (
            <li className="mb-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <span className="rounded-full shadow-lg uppercase">
                  {userFirstLetter.charAt(0)}
                </span>
              </span>
              <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600">
                {/* <time
                  className="mb-1 cursor-pointer text-xs font-normal text-gray-500 sm:order-last sm:mb-0"
                  title={"dateAndTimeFormat(item.timeStamp)"}
                >
                  {"timeDiffer(item.timeStamp)"} ago
                </time> */}
                <div className="text-sm font-normal text-gray-600 dark:text-gray-400 uppercase">
                  {" "}
                  {"Pages Name -"}
                  <span className="bg-gray-100 text-gray-800 text-xs font-normal me-2 px-2.5 py-0.5 rounded dark:bg-gray-600 dark:text-gray-300">
                    {item.pageName}
                  </span>
                </div>
              </div>
              <time className="block m-2 text-sm font-normal leading-none text-gray-500 dark:text-gray-500">
                {"All Events"}
              </time>
              {item.pageLists.map((ele) => (
                <>
                  {ele.enable && (
                    <div className=" m-2 p-3 text-xs font-normal text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-600 dark:border-gray-500 dark:text-gray-300">
                      <li>
                        <li>{ele.text}</li>
                      </li>
                    </div>
                  )}
                </>
              ))}
            </li>
          ))}
        </ol>
      </Card>
      <Card extra={"w-full h-full p-6 mt-2"}>
        <div className="mt-2 mb-8 w-full">
          <h3 className="px-2 font-bold text-navy-700 dark:text-white uppercase">
            {"Feature Activity"}
          </h3>
        </div>
        <div className="grid grid-cols-1 gap-4 px-2">
          {params.visitedUserInfo.length !== 0 ? (
            params.visitedUserInfo.map((user) => (
              <>{textComponent("User Name", user.userName)}</>
            ))
          ) : (
            <div className=" text-gray-600">No User Activity found</div>
          )}
        </div>
      </Card>
    </>
  );
}
